import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Tab } from 'app/model/tabs.model';

@Component({
  selector: 'iv-live-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit {
  @Input() tab: Tab | null = null;
  @Input() closeable: Tab | null = null;
  @Input() index: number | null = null;
  @ViewChild('editInput') editInput: ElementRef | null = null;
  @Output() onCloseTab: EventEmitter<number> = new EventEmitter()
  @Output() onEditTitle: EventEmitter<boolean> = new EventEmitter()
  @Output() saveTitle: EventEmitter<null> = new EventEmitter()
  public isEditTitle: boolean = false;
  public initialName: string = ''

  constructor() {}

  public ngOnInit() {
    this.initialName = this.tab.name
  }

  public toggleEditTitle(): void {
    this.isEditTitle = !this.isEditTitle;
    if (this.isEditTitle) {
      setTimeout(() => {
        this.editInput.nativeElement.focus()
      })
    } else {
      if (this.tab.name.length > 0) {
        this.initialName = this.tab.name
        this.saveTitle.emit()
      } else {
        this.restoreTitle()
        this.isEditTitle = !this.isEditTitle
      }
    }
    this.onEditTitle.emit(this.isEditTitle)
  }

  public closeTab(i: number): void {
    this.onCloseTab.emit(i)
  }

  public restoreTitle(): void {
    this.tab.name = this.initialName
    this.isEditTitle = !this.isEditTitle
    this.onEditTitle.emit(this.isEditTitle)
  }
}
